__webpack_require__.p = "/Swiss-architects/";